import App from './components/App/App';
import './index.css';
import './assets/css/bootstrap.css';
import './assets/css/style.css';
import './assets/css/mine.css';
import './assets/css/global/global.css';
import './assets/css/all.css';
import './assets/css/sharp-regular.css';
import './assets/css/sharp-solid.css'

import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { createRoot } from 'react-dom/client';
import Welcome from './components/Welcome/Welcome';
import Dashboard from './components/Dashboard/Dashboard';
import Register from './components/auth/Register';
import SignIn from './components/auth/SignIn';
import { UserProvider } from './context/UserContext';
import ProtectedRoute from './helper/ProtectedRoute';
import CreateTree from './components/Dashboard/CreateTree';
import AboutUs from './components/Welcome/AboutUs';
import Contact from './components/Welcome/Contact';
import UserStories from './components/Welcome/UserStories';
import AIDrivenFamilyDiscovery from './components/Welcome/services/AIDrivenFamilyDiscovery';
import DNATestingAndMatching from './components/Welcome/services/DNATestingAndMatching';
import FamilyTreeBuilding from './components/Welcome/services/FamilyTreeBuilding';
import IgitreeConnect from './components/Welcome/services/IgitreeConnect';
import { EditFamilyNodeProvider } from './context/EditFamilyNodeContext';
import ForgetPasswordForm from './components/auth/ForgetPasswordForm';
import ResetPasswordForm from './components/auth/ResetPasswordForm';
import VerifyEmail from './components/auth/VerifyEmail';
import PrivacyPolicy from './components/Welcome/PrivacyPolicy';
import FirebaseNotificationSetup from './components/notifications/FirebaseNotificationSetup';
import { ToastContainer } from 'react-toastify';
import { NotificationProvider } from './context/NotificationsContext';
import Upgrade from './components/Dashboard/Upgrade';
import QuestionsHolder from './components/questionaire/HoldIngQuestion';
import NewBlog from './components/blog/NewBlog';
import BlogDetail from './components/blog/BlogDetail';
import EditBlog from './components/Welcome/blog/EditBlog';
import LandingSelector from './components/Landing/LandingSelector';
import AnimalGeneticsLanding from './components/Landing/AnimalGeneticsLanding';
import HumanGeneticsLanding from './components/Landing/HumanGeneticsLanding';



const router = createBrowserRouter([
    {
        path: '/',
        element: <LandingSelector
        />
    },
    {
        path: '/igisekuruza',
        element: <Welcome
        />
    },
    {
        path: '/animal-genetics',
        element: <AnimalGeneticsLanding
        />
    },
    {
        path: '/human-genetics',
        element: <HumanGeneticsLanding
        />
    },
    {
        path: '/dashboard',
        element: <ProtectedRoute>
            <Dashboard
                page="DashBoard"
                keywords="sample, keywords"
                description="Sample description"
                twitter="sampleTwitterHandle"
                services={[]}
                notifications={[]}

            />
        </ProtectedRoute>,
    },
    {
        path: '/upgrade',
        element: <ProtectedRoute>
            <Upgrade
                // page="Upgrade"
                // keywords="Igitree, payment page"
                // description="Sample description"
                // twitter="sampleTwitterHandle"
                // services={[]}
                // notifications={[]}

            />
        </ProtectedRoute>,
    },
    {
        path: '/register',
        element: <Register />,
    },
    {
        path: '/login',
        element: <SignIn />,
    },
    {
        path: '/newtree',
        element: <CreateTree pageTitle={''} />,
    },
    {
        path: '/tree/:board_id',
        element:<ProtectedRoute><App /></ProtectedRoute> ,
    },

    {
        path: '/privacy_policy',
        element: <PrivacyPolicy />,
    },

    {
        path: '/ai-driven-family-discovery',
        element:  <AIDrivenFamilyDiscovery

    />},
    {
      path:'/family-match',
      element:<QuestionsHolder/>  
    },

    {
        path: '/dna-testing-and-matching',
        element:  <DNATestingAndMatching

    />},
    {
        path: '/family-tree-build',
        element:  <FamilyTreeBuilding

    />}, 

   {
    path: '/igitree-connect',
    element: <IgitreeConnect
    />},

 {
        path: '/about',
        element:  <AboutUs

    />},
    {
        path: '/contact',
        element:  <Contact

    />},
    {
        path: '/contacts',
        element:  <Contact

    />},
    {
        path: '/user-stories',
        element:  <UserStories

    />}, 
    {
        path: '/forgot',
        element:  <ForgetPasswordForm

    />},
    {
        path: '/newblog',
        element:  <NewBlog

    />},
    {
        path: '/blog/:blogId',
        element:  <BlogDetail

    />},
    {
        path: '/edit-blog/:id',
        element:  <EditBlog

    />},
    {
        path: '/verify',
        element:  <VerifyEmail

    />},
    // {
    //     path: '/pay',
    //     element:  <IremboPaymentButton 

    // />},
    {
        path: '/reset-password',
        element:  <ResetPasswordForm

    />},
]);

if ('serviceWorker' in navigator) {
    window.addEventListener('load', async () => {
      try {
        await navigator.serviceWorker.register('/firebase-messaging-sw.js');
        // console.log('Service Worker registered with scope:', registration.scope);
      } catch (error) {
        console.error('Service Worker registration failed:', error);
      }
    });
  }

createRoot(document.getElementById('root')!).render(
    <UserProvider>
        <ToastContainer  />
        <EditFamilyNodeProvider>
        <FirebaseNotificationSetup />
        <NotificationProvider>
        <RouterProvider router={router} />
        </NotificationProvider>
        </EditFamilyNodeProvider>
    </UserProvider>
);














